import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find-index.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "home-gai"
};
var _hoisted_2 = {
  class: "tab"
};
var _hoisted_3 = {
  class: "gai-content"
};
import { ref, computed, onMounted, onBeforeMount } from 'vue';
import NavTab from '../Components/NavTab.vue';
import Correct from './Correct/index.vue';
import Analysis from './Analysis/index.vue';
import { appAliasEvent } from '@/utils/auth.js';
import useUserStore from '@/stores/modules/user';
import { storeToRefs } from 'pinia';
import { validateNull } from '@/util/validate';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var emptyImg = require('@/assets/noData.png');
    var _storeToRefs = storeToRefs(useUserStore()),
      appAliasUrl = _storeToRefs.appAliasUrl;
    var tabs = [{
      name: '批改作业',
      value: 1,
      component: Correct,
      exist: true
    }, {
      name: '学情分析',
      value: 2,
      component: Analysis,
      exist: false
    }];
    var defaultIndex = ref(1);
    var currentComponent = computed(function () {
      var index = tabs.findIndex(function (item) {
        return item.value === defaultIndex.value;
      });
      return tabs[index].component;
    });
    var isLoading = ref(true);
    var isEmpty = computed(function () {
      return !isLoading.value && validateNull(appAliasUrl.value);
    });
    var handleChangeTab = function handleChangeTab(item) {
      defaultIndex.value = item.value;
    };
    onMounted(function () {
      initApp();
    });
    var initApp = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              isLoading.value = true;
              _context.n = 1;
              return appAliasEvent('inspirationCentre', false);
            case 1:
              appAliasUrl.value = _context.v;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              _context.p = 3;
              isLoading.value = false;
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2, 3, 4]]);
      }));
      return function initApp() {
        return _ref.apply(this, arguments);
      };
    }();
    onBeforeMount(function () {
      appAliasUrl.value = null;
    });
    return function (_ctx, _cache) {
      var _component_empty = _resolveComponent("empty");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(NavTab, {
        tabs: tabs,
        "default-index": defaultIndex.value,
        onChange: handleChangeTab
      }, null, 8, ["default-index"])]), _createElementVNode("div", _hoisted_3, [isEmpty.value ? (_openBlock(), _createBlock(_component_empty, {
        key: 0,
        class: "p-c",
        icon: _unref(emptyImg),
        text: "无备课权限"
      }, null, 8, ["icon"])) : (_openBlock(), _createBlock(_resolveDynamicComponent(currentComponent.value), {
        key: 1
      }))])]);
    };
  }
};